import { createSlice } from '@reduxjs/toolkit';

//FIXME: replace the hardcoded vals with enums
const canvasSlice = createSlice({
    name:'canvas',
    initialState: {
        canvas:null,
        selectedPanel: '1',
        activeObject : null,
        activeTab: 1,
        canvasDimensions: false,
        activeColorSetting:{},
        activeSetting: {
            height: 100,
            width: 100,
            scaleX: 1,
            scaleY: 1,
            top: 0,
            left: 0,
            dpi: 0,
            objectType: 'none',
            isLockScaling: false,
            fontFamily: '',
            fontSize: '',
            fontStyle: '',
            textAlignment: '',
            fontWeight: '',
            underline: '',
            textColor: '',
            shadow: {},
            strokeWidth:0,
            textGradient: false,
            stroke: '',
            isShadow: false,
            isOutline: false
        }
    },
    reducers:{
        setFabricCanvasInstance:(state,action)=>{
            state.canvas = action.payload
        },
        changePanel:(state,action)=>{
            state.selectedPanel = action.payload
        },
        setActiveObject:(state,action)=>{
            state.activeObject = action.payload
        },
        setActiveTab: (state, action) => {
            state.activeTab = action.payload
        },
        setCanvasDimensions: (state, action) => {
            state.canvasDimensions = action.payload
        },
        setActiveSetting: (state, action) => {
            state.activeSetting = action.payload;
        },
        setActiveColorSetting: (state, action) => {
            state.activeColorSetting = action.payload;
        }
    }
})
export const {setFabricCanvasInstance,changePanel,setActiveObject, setActiveTab, setActiveSetting, setActiveColorSetting, setCanvasDimensions} = canvasSlice.actions;
export default canvasSlice.reducer;
